exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n\n/* styling of the editor menubar*/\n.jsoneditor-menu a.jsoneditor-poweredBy {\n    color: #ffffff;\n}\ndiv.jsoneditor,\ndiv.jsoneditor-menu {\n    border-color: #00796B;\n}\ndiv.jsoneditor-menu {\n    background-color: #00796B;\n}\n\n", ""]);

// exports
